import React, { useState, useRef, useEffect } from 'react';
import '../Become.css';
import { Button } from '../../../components/Button/index';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import InputFeild from '../../../components/Input/Input'
import { useNavigate } from 'react-router-dom';

const ForgotOtpScreen = ({ email, item }) => {
  const [otp, setOTP] = useState(['', '', '', '']);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [token, setToken] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false); 
  const [newPassword, setNewPassword] = useState(''); 
  const inputRefs = useRef([]);

  const handleRedirect = () => {
    if (item === 'admin') {
      navigate('/super-admin-login');
    } else if (item === 'seller') {
      navigate('/sign-in');
    } else {
      console.log('Invalid role');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const newOTP = [...otp];
      newOTP[index] = value.substring(value.length - 1);
      setOTP(newOTP);
      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        const newOTP = [...otp];
        newOTP[index - 1] = ''; 
        setOTP(newOTP);
        inputRefs.current[index - 1].focus(); 
      }
    }
  };

  const handleSubmitOtp = async () => {
    const otpValue = otp.join('');
    if (otpValue.length < 4) {
      setError("Please enter 4-digit code");
      return;
    }

    setLoading(true);
    setError(null);

    const payload = {
      code: otpValue,
      role: item,
      email: email
    };

    try {
      const response = await axios.post('https://backend.washta.com/api/otp/verifyCode', payload, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.status && response.data.code === 200) {
        setError('');
        setToken(response.data.data.token);
        setIsOtpVerified(true);
      } else {
        setError('OTP verification failed');
      }
    } catch (error) {
      console.error('Error during OTP verification:', error.response?.data);
      setError(error.response?.data?.error || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!newPassword) {
      setError('Password cannot be empty');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        token: token,
        role: item,
        newPassword: newPassword
      };
      const response = await axios.post('https://backend.washta.com/api/otp/setPassword', payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.status && response.data.code === 200) {
        setError('');
        handleRedirect();
      } else {
        setError('Failed to change password');
      }
    } catch (error) {
      console.error('Error during password change:', error.response?.data);
      setError(error.response?.data?.error || "Error updating password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-container fade-in">
      <h1 className='h1-heaing'>{isOtpVerified ? 'Set Your New Password' : 'Enter your verification code'}</h1>
      <p className='paragraph-otp'>
        {isOtpVerified 
          ? 'Enter your new password below to complete the process.' 
          : 'Enter 4 digit verification code sent to your registered Email Verification.'}
      </p>

      <div className="otp-input-container">
        {!isOtpVerified ? (
          otp.map((digit, index) => (
            <input
              key={index}
              ref={el => inputRefs.current[index] = el}
              className="otp-input"
              type="text"
              inputMode="numeric"
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)} // Backspace logic added here
            />
          ))
        ) : (
          <div className='gapmargin' style={{width:'100%', textAlign:'left'}}>
            <InputFeild
              label="New Password"
              placeholder="Enter new password"
              type="password"
              value={newPassword}
              onChange={setNewPassword}
              paddingBottom="10px"
            />
          </div>
        )}
      </div>
      
      {error && <p className='error-paragrhp' style={{color: 'red', marginTop: '10px'}}>{error}</p>}

      <div className="actions-container">
        {!isOtpVerified ? (
          <Button
            onClick={handleSubmitOtp}
            shape="round"
            className="min-w-[100%] sm:px-1"
            style={{ fontSize: '16px', background: 'white', color: 'black', marginTop: '20px', fontFamily: "'General Sans', sans-serif" }}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" style={{ color: '#6b5fe4', width: '1.5em', height: '1.5em' }} size="sm" /> : 'Submit'}
          </Button>
        ) : (
          <Button
            onClick={handleChangePassword}
            shape="round"
            className="min-w-[100%] sm:px-1"
            style={{ fontSize: '16px', background: 'white', color: 'black', marginTop: '20px', fontFamily: "'General Sans', sans-serif" }}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" style={{ color: '#6b5fe4', width: '1.5em', height: '1.5em' }} size="sm" /> : 'Change Password'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ForgotOtpScreen;